module.exports = __webpack_public_path__ + "static/img/bart-starr.deb0e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bart-starr.png
// module id = 4SAv
// module chunks = 1